import React from "react";
import { useTranslation } from "react-i18next";
import { Profile } from "../../../types/types";
import { convertToYouTubeEmbedUrl } from "../../../utils/utilMethods";
import Carousel from "./carousel";

interface YouTubeLinksProps {
    member: Profile;
}

const YouTubeLinks: React.FC<YouTubeLinksProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    const links = member.fighter.ytLinksDetails ?? [];

    return (
        <div className="space-y-3" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            <h3 className="text-sm font-medium text-gray-900 text-start">
                {t("youtube_links")}
            </h3>
            {links.length ? (
                <Carousel itemClassName="w-[90%] md:w-[48%] lg:w-[36%]">
                    {links.map((link: any, index: any) => {
                        const embedUrl = convertToYouTubeEmbedUrl(link.ytLink);
                        return embedUrl ? (
                            <div
                                key={index}
                                className="aspect-video w-full rounded-2xl overflow-hidden bg-black"
                            >
                                <iframe
                                    className="w-full h-full"
                                    src={embedUrl}
                                    title={`YouTube video player - ${link.shortTitle ?? index + 1}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        ) : (
                            <div
                                key={index}
                                className="aspect-video w-full rounded-2xl bg-gray-50 flex items-center justify-center"
                            >
                                <p className="text-xs text-red-500">
                                    {t("invalid_youtube_url")}
                                </p>
                            </div>
                        );
                    })}
                </Carousel>
            ) : (
                <p className="text-gray-400 text-xs text-center py-8">
                    {t("no_youtube_links")}
                </p>
            )}
        </div>
    );
};

export default YouTubeLinks;
